import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { AuthenticationWorkflow, LoginContext } from '@jts-shared/auth';

import { Credentials, CredentialsService } from './credentials.service';

export type { LoginContext };

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService extends AuthenticationWorkflow {
  constructor(credentialsService: CredentialsService) {
    super(credentialsService);
  }

  login(context: LoginContext): Observable<Credentials> {
    return of(this.performLogin(context));
  }

  logout(): Observable<boolean> {
    return of(this.performLogout());
  }
}
